import { render, staticRenderFns } from "./CarbonCreditsMarketStatus.vue?vue&type=template&id=8800726e&scoped=true"
import script from "./CarbonCreditsMarketStatus.vue?vue&type=script&lang=js"
export * from "./CarbonCreditsMarketStatus.vue?vue&type=script&lang=js"
import style0 from "./CarbonCreditsMarketStatus.vue?vue&type=style&index=0&id=8800726e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8800726e",
  null
  
)

/* custom blocks */
import block0 from "./CarbonCreditsMarketStatus.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports